import React, { useState, useEffect } from 'react';

const Countdown = ({ targetTime, onComplete }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetTime));

    useEffect(() => {
        const timer = setInterval(() => {
            const updatedTimeLeft = calculateTimeLeft(targetTime);
            setTimeLeft(updatedTimeLeft);

            // Trigger the onComplete callback when time reaches zero
            if (updatedTimeLeft.total <= 0) {
                clearInterval(timer);
                if (onComplete) {
                    onComplete();
                }
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [targetTime, onComplete]);

    function calculateTimeLeft(targetTime) {
        const difference = targetTime - new Date();
        if (difference <= 0) {
            return { hours: 0, minutes: 0, seconds: 0, total: 0 };
        }

        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        return { hours, minutes, seconds, total: difference };
    }

    const { hours, minutes, seconds } = timeLeft;

    return (
        <div className='flex w-full h-full justify-center'>
            <div
                className="text-7xl font-bold dark:text-blue-500 text-blue-700 flex justify-center items-center"
                style={{ width: '12ch', textAlign: 'center' }} // Adjust width as needed
            >
                {hours > 0 && `${String(hours).padStart(2, '0')} : `}
                {`${String(minutes).padStart(2, '0')} : `}
                {`${String(seconds).padStart(2, '0')}`}
            </div>
        </div>
    );
};

export default Countdown;